import React from 'react';
import { Row } from 'react-bootstrap';
import * as Styled from './mobileNavigationStyles';
import useMenus from '../../../hooks/useMenus';
import arrowDown from '../../../images/arrow-blue-mobile-nav.png';
import MobileSearchSite from '../../searchSite/mobileSearchSite';
import iconHome from '../../../images/icon-home.png';
import isExternalUrl, {
  addTrailingSlash,
  isExternalUrlhref,
} from '../../../utils';

const MobileNavbar = () => {
  const [showSearchSite, setShowSearchSite] = React.useState(false);
  const [showRequestCallback, setShowRequestCallback] = React.useState(false);
  const [showMenu, setShowMenu] = React.useState(false);
  const [showSubNavigation, setShowSubNavigation] = React.useState(false);
  const [navIndex, setNavIndex] = React.useState();
  const [subNavIndex, setSubNavIndex] = React.useState();
  const menu = useMenus();

  const onClickSearch = () => {
    setShowSearchSite((prev) => !prev);
    setShowRequestCallback(false);
    setShowMenu(false);
  };
  const onClickTool = () => {
    setShowSearchSite(false);
    setShowRequestCallback((prev) => !prev);
    setShowMenu(false);
  };
  const onClickMenu = () => {
    setShowSearchSite(false);
    setShowRequestCallback(false);
    setShowMenu((prev) => !prev);
  };

  return (
    <React.Fragment>
      <Styled.MainContainer fluid>
        <Styled.TopLogoAnchor
          href={addTrailingSlash(process.env.GATSBY_DOMAIN_URL)}
        >
          <Styled.TopLogo
            src={menu?.imageWithPath[1]?.image?.file?.url}
            alt={menu?.imageWithPath[1]?.title}
          />
        </Styled.TopLogoAnchor>
        <Styled.TopNav>
          <Styled.NavMenu
            className={showMenu && 'active'}
            onClick={onClickMenu}
          ></Styled.NavMenu>
          <Styled.NavTool
            className={(showRequestCallback)&&
              'active'
            }
            onClick={onClickTool}
          ></Styled.NavTool>

          <Styled.NavSearchSite
            className={showSearchSite && 'active'}
            onClick={onClickSearch}
          ></Styled.NavSearchSite>
        </Styled.TopNav>
      </Styled.MainContainer>
      <Styled.DropDownContainer>
        {showSearchSite && <MobileSearchSite />}
        {showRequestCallback && (
          <>
            <Row className="g-0">
              <Styled.RelativeCol xs={12}>
                <Styled.HeaderMenu
                  href={addTrailingSlash(process.env.GATSBY_DOMAIN_URL)}
                >
                  Home
                  <Styled.IconHome src={iconHome} />
                </Styled.HeaderMenu>
              </Styled.RelativeCol>
            </Row>
          </>
        )}
        {showMenu &&
          menu?.navigations?.map((item, index) => {
            return (
              <div key={index}>
                <Row className="g-0">
                  <Styled.RelativeCol>
                    <Styled.HeaderMenu
                      href={
                        isExternalUrlhref(item?.entryWithPath?.path)
                          ? item?.entryWithPath?.path
                          : addTrailingSlash(
                              process.env.GATSBY_DOMAIN_URL +
                                item?.entryWithPath?.path
                            )
                      }
                      target={
                        isExternalUrl(item?.entryWithPath?.path)
                          ? '_blank'
                          : '_self'
                      }
                    >
                      {item?.entryWithPath?.text.toLowerCase()}
                    </Styled.HeaderMenu>
                    {item?.subNavigations && (
                      <Styled.ArrowImageContainer
                        onClick={() => {
                          if (navIndex === index) {
                            setShowSubNavigation(false);
                            setNavIndex(-1);
                            setSubNavIndex(-1);
                          } else {
                            setShowSubNavigation(true);
                            setSubNavIndex(-1);
                            setNavIndex(index);
                          }
                        }}
                      >
                        <Styled.ArrowImage src={arrowDown} alt="" />
                      </Styled.ArrowImageContainer>
                    )}
                  </Styled.RelativeCol>
                  {index === navIndex &&
                    item?.subNavigations &&
                    showSubNavigation && (
                      <div>
                        {item?.subNavigations?.map((itemSub, index) => {
                          return (
                            <Styled.RelativeCol xs={12} key={index}>
                              <Styled.SubHeaderMenu
                                href={
                                  isExternalUrlhref(itemSub?.textWithPath?.path)
                                    ? itemSub?.textWithPath?.path
                                    : addTrailingSlash(
                                        process.env.GATSBY_DOMAIN_URL +
                                          itemSub?.textWithPath?.path
                                      )
                                }
                                target={
                                  isExternalUrl(itemSub?.textWithPath?.path)
                                    ? '_blank'
                                    : '_self'
                                }
                              >
                                {itemSub?.textWithPath?.text.toLowerCase()}
                              </Styled.SubHeaderMenu>
                            </Styled.RelativeCol>
                          );
                        })}
                      </div>
                    )}
                </Row>
              </div>
            );
          })}
      </Styled.DropDownContainer>
    </React.Fragment>
  );
};

export default MobileNavbar;
